import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import createLogger from 'redux-logger'
import formatMessage from 'format-message'
import { convertStringBool } from '../utils'

import ReaderNavigationContainer from './components/ReaderNavigationContainer'
import ReaderToolbarContainer from './components/ReaderToolbarContainer'
import ToolbarButton from './components/ToolbarButton'
import NewReaderNavigationContainer from './components/new_ReaderNavigationContainer'
import NewToolbarButton from './components/new_ToolbarButton'

const RESPONSIVE_DEVICE_WIDTH = 768

formatMessage.setup({
  // don't console.warn or throw an error when a translation is missing
  missingTranslation: 'ignore',
})

const defaultState = {
  responsiveDeviceWidth: RESPONSIVE_DEVICE_WIDTH,
  showReaderToolbarModal: false,
  showReaderNavigationModal: false,
  navigationToolbarData: {
    sectionTitleInfo: {
      sectionTitle: '',
      pageroot: '',
    },
    navigationToolbarRows: [
      {
        title: '',
        label: '',
        node: '',
        url: '',
      },
    ],
  },
}

const rootReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'TOGGLE_READER_TOOLBAR_MODAL':
      return {
        ...state,
        showReaderToolbarModal: action.payload,
      }
    case 'TOGGLE_READER_NAVIGATION_MODAL':
      return {
        ...state,
        showReaderNavigationModal: action.payload,
      }
    case 'UPDATE_NAVIGATION_TOOLBAR':
      return {
        ...state,
        navigationToolbarData: {
          ...state.navigationToolbarData,
          ...action.navigationToolbarData,
        },
      }
    default:
      return state
  }
}

const middlewares =
  process.env.NODE_ENV === 'production'
    ? applyMiddleware(thunk)
    : applyMiddleware(thunk, createLogger())
let store = compose(middlewares)(createStore)(rootReducer)

export let startReader = (
  coursePK,
  coursenum,
  courseTitle,
  notebook,
  authorTools,
  userRole,
  chapterID,
  pageID,
  showSectionNumbers
) => {
  let allowNotebook = convertStringBool(notebook)
  let allowAuthorTools = convertStringBool(authorTools)
  let displaySectionNumbers = convertStringBool(showSectionNumbers)

  let glossaryModalFunc = () => {
    $.meDialog.open2({
      id: 'dialog_view_glossary',
      url: '/reader/glossary.view/' + coursenum + '/',
      title: formatMessage('Glossary: ') + courseTitle,
    })
  }
  let advancedOptionsModalFunc = () => {
    $.meDialog.open2({
      id: 'dialog_advanced_options',
      url: '/reader/booktools.advanced_options/' + coursenum + '/',
      title: formatMessage('Advanced Options'),
      width: '600px',
    })
  }

  let readerToolbarNode = document.getElementById('reader_toolbar')
  let readerNavigationNode = document.getElementById('reader_navigation')
  let rightToolbarButtonNode = document.getElementById('rightToolbarButton')
  let leftToolbarButtonNode = document.getElementById('leftToolbarButton')

  if (readerNavigationNode) {
    ReactDOM.render(
      <Provider store={store}>
        <ReaderNavigationContainer
          chapterID={chapterID}
          pageID={pageID}
          displaySectionNumbers={displaySectionNumbers}
        />
      </Provider>,
      readerNavigationNode
    )
  }

  if (readerToolbarNode) {
    ReactDOM.render(
      <Provider store={store}>
        <ReaderToolbarContainer
          coursePK={coursePK}
          coursenum={coursenum}
          glossaryModalFunc={glossaryModalFunc}
          allowNotebook={allowNotebook}
          allowAuthorTools={allowAuthorTools}
          userRole={userRole}
          advancedOptionsModalFunc={advancedOptionsModalFunc}
        />
      </Provider>,
      readerToolbarNode
    )
  }

  if (rightToolbarButtonNode) {
    ReactDOM.render(
      <Provider store={store}>
        <ToolbarButton position="right" />
      </Provider>,
      rightToolbarButtonNode
    )
  }

  if (leftToolbarButtonNode) {
    ReactDOM.render(
      <Provider store={store}>
        <ToolbarButton position="left" />
      </Provider>,
      leftToolbarButtonNode
    )
  }
}

export let startNewReader = (
  coursePK,
  coursenum,
  courseTitle,
  notebook,
  authorTools,
  userRole,
  chapterID,
  pageID,
  showSectionNumbers
) => {
  let allowNotebook = convertStringBool(notebook)
  let allowAuthorTools = convertStringBool(authorTools)
  let displaySectionNumbers = convertStringBool(showSectionNumbers)

  let glossaryModalFunc = () => {
    $.meDialog.open2({
      id: 'dialog_view_glossary',
      url: '/reader/glossary.view/' + coursenum + '/',
      title: formatMessage('Glossary: ') + courseTitle,
    })
  }
  let advancedOptionsModalFunc = () => {
    $.meDialog.open2({
      id: 'dialog_advanced_options',
      url: '/reader/booktools.advanced_options/' + coursenum + '/',
      title: formatMessage('Advanced Options'),
      width: '600px',
    })
  }

  let readerToolbarNode = document.getElementById('reader_toolbar')
  let readerNavigationNode = document.getElementById('reader_navigation')
  let rightToolbarButtonNode = document.getElementById('rightToolbarButton')
  let leftToolbarButtonNode = document.getElementById('leftToolbarButton')

  if (readerNavigationNode) {
    ReactDOM.render(
      <Provider store={store}>
        <NewReaderNavigationContainer
          chapterID={chapterID}
          pageID={pageID}
          displaySectionNumbers={displaySectionNumbers}
        />
      </Provider>,
      readerNavigationNode
    )
  }

  if (readerToolbarNode) {
    ReactDOM.render(
      <Provider store={store}>
        <ReaderToolbarContainer
          coursePK={coursePK}
          coursenum={coursenum}
          glossaryModalFunc={glossaryModalFunc}
          allowNotebook={allowNotebook}
          allowAuthorTools={allowAuthorTools}
          userRole={userRole}
          advancedOptionsModalFunc={advancedOptionsModalFunc}
        />
      </Provider>,
      readerToolbarNode
    )
  }

  if (rightToolbarButtonNode) {
    ReactDOM.render(
      <Provider store={store}>
        <NewToolbarButton position="right" />
      </Provider>,
      rightToolbarButtonNode
    )
  }

  if (leftToolbarButtonNode) {
    ReactDOM.render(
      <Provider store={store}>
        <NewToolbarButton position="left" />
      </Provider>,
      leftToolbarButtonNode
    )
  }
}
